import { render, staticRenderFns } from "./EventPurchase.vue?vue&type=template&id=068cc050&scoped=true&"
import script from "./EventPurchase.vue?vue&type=script&lang=js&"
export * from "./EventPurchase.vue?vue&type=script&lang=js&"
import style0 from "./EventPurchase.vue?vue&type=style&index=0&id=068cc050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068cc050",
  null
  
)

export default component.exports